import { render } from "./InfoTable.vue?vue&type=template&id=fb97b51c"
import script from "./InfoTable.vue?vue&type=script&lang=js"
export * from "./InfoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__